module.exports = __webpack_public_path__ + "static/media/400066_01.b371fa8d.png";